import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogComponent } from 'src/app/dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DatabaseService } from 'src/_services/DatabaseService';
import { sessionStorage } from 'src/app/localstorage.service';
import { Location } from '@angular/common'
import { ToastrManager } from 'ng6-toastr-notifications';
import { StatusModalComponent } from '../status-modal/status-modal.component';
import { ImageModuleComponent } from 'src/app/image-module/image-module.component';
// import * as ExcelJS from 'exceljs';



@Component({
  selector: 'app-secondary-order-detail',
  templateUrl: './secondary-order-detail.component.html'
})
export class SecondaryOrderDetailComponent implements OnInit {
  orderType: any = 'order';
  status: any;
  id: any;
  login_data: any = [];
  secondaryOrderDetail: any = [];
  distributorInfo: any = []
  order_logs: any = []
  item_details: any = []
  url: any = '';
  editqty: any = false;
  Order_Amount: any;
  login_dr_id: any;
  skLoading: boolean = false;
  siteDetails: any = [];
  totalPrimaryValue: number;
  primaryGstAmount: number;
  grandtotalPrimaryValue: any;
  influencerdetails: any;

  constructor(public route: ActivatedRoute, public location: Location, public serve: DatabaseService, public dialog: MatDialog, public session: sessionStorage, public dialogs: DialogComponent, public toast: ToastrManager, public route1: Router,) {
    this.login_data = this.session.getSession();
    this.login_data = this.login_data.value.data;

    if (this.login_data.access_level != '1') {
      this.login_dr_id = this.login_data.id;
    }
    this.route.params.subscribe(params => {
      this.status = this.route.queryParams['_value']['status'];



    });
    this.url = serve.uploadUrl + 'site/';
    console.log(this.url)


  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      // this.id = this.serve.crypto(params['id'],false);
      this.serve.currentUserID = params['id'];


      if (this.route.queryParams['_value']['routes']) {
        this.serve.currentUserID = this.route.queryParams['_value']['id']
      }

      // this.serve.currentUserID = this.serve.crypto(params['id'],false)
      if (this.id) {
        // this.loader = true;
        this.getSecondaryOrderDetails();
      }
    });
  }
  goToImage(image) {
    const dialogRef = this.dialog.open(ImageModuleComponent, {
      panelClass: 'Image-modal',
      data: {
        'image': image,
        'type': 'base64'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

  }

  getSecondaryOrderDetails() {
    this.skLoading = true;
    setTimeout(() => {
      this.serve.post_rqst({ 'id': this.id }, "Order/secondaryOrderDetail")
        .subscribe((result => {
          if (result['statusCode'] == 200) {
            this.skLoading = false;
            this.secondaryOrderDetail = result['result']
            this.distributorInfo = result['result']['distributor_info']
            this.order_logs = result['result']['order_log']

            this.siteDetails = result['result']['site_details']
            console.log(this.siteDetails)

            this.influencerdetails = result['result']['site_details']['influencerArray']
            console.log("INfluencer",this.influencerdetails)
            this.item_details = result['result']['item_info'];
            this.Order_Amount = Number(this.secondaryOrderDetail.order_total) + Number(this.secondaryOrderDetail.order_discount)
            if (this.item_details.length > 0) {
              this.totalPrimaryValue = 0;
              this.primaryGstAmount = 0; // Resetting before summing up
              this.grandtotalPrimaryValue = 0; 
            
              this.item_details.forEach(item => {
                this.totalPrimaryValue += item.price_with_discount; // Sum up discounted prices
                this.grandtotalPrimaryValue += item.price_with_freight; // Sum up discounted prices
                this.primaryGstAmount += item.price_with_freight - item.price_with_discount; // Calculate GST amount
              });
            }
            
          } else {
            this.toast.errorToastr(result['statusMsg']);
            this.skLoading = false;
          }
        }))
    }, 700);
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(StatusModalComponent, {
      width: '400px', data: {
        order_status: this.secondaryOrderDetail.order_status,
        order_id: this.id,
        from: 'Secondary_order',
        reason: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getSecondaryOrderDetails();
    });
  }
  addRemark(): void {
    const dialogRef = this.dialog.open(StatusModalComponent, {
      width: '400px', data: {
        order_status: this.secondaryOrderDetail.order_status,
        order_id: this.id,
        from: 'Secondary_order_remark',
        reason: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getSecondaryOrderDetails();
    });
  }
  edit_qty() {
    this.editqty = true;
  }
  deleteOrderitem(order_id, index) {
    this.dialogs.confirm("You want to delet this item !").then((result) => {
      if (result) {
        this.serve.post_rqst({ 'id': order_id }, "Order/secondaryOrderDeleteItem")
          .subscribe((result => {
            if (result['statusCode'] == 200) {
              this.toast.successToastr(result['statuMsg']);
              this.item_details.splice(index, 1)
              this.getSecondaryOrderDetails();
            } else {
              this.toast.errorToastr(result['statuMsg'])
            }

          }))
      }
    })
  }
  Update_qty(id) {
    let index = this.item_details.findIndex(row => row.id == id)

    let cart_data = []
    let Amount = (this.item_details[index].qty * this.item_details[index].price)
    this.item_details[index].product_price = this.item_details[index].price
    this.item_details[index].discounted_price = this.item_details[index].discount_amount
    this.item_details[index].dr_disc = this.item_details[index].discount_percent
    this.item_details[index].total_amount = Amount;
    cart_data.push(this.item_details[index])

    this.serve.post_rqst({ 'id': id, 'cart_data': cart_data }, "Order/secondaryOrderUpdateItem").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.editqty = false;
        this.toast.successToastr('Quantity Updated Successfully');
      }
      else {
        this.editqty = false;
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }
  back(): void {
    this.location.back()
  }

  exportPdf() {
    this.skLoading = true;
    let id = { 'id': this.id }
    this.serve.post_rqst(id, "Order/exportSecondaryOrderPdf").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.skLoading = false;
        window.open(this.serve.uploadUrl + 'orderPdf/' + result['file_name']);
      } else {
        this.skLoading = false;
        this.toast.errorToastr(result['statusMsg'])
      }
    }
      , err => {
        this.skLoading = false;

      }
    )
  }

  async exportExcelTotal() {
    const ExcelJS = await import('exceljs');
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Order Details');

    // Add company name, contact details, and "Created By" rows
    const companyName = this.secondaryOrderDetail.company_name;
    const contactDetails = 'Contact: '+ this.secondaryOrderDetail.mobile+' | Name: ' + this.secondaryOrderDetail.name;
    const createdBy = 'Created By: ' + this.secondaryOrderDetail.created_by_name;

    // Adding company details as a header
    worksheet.mergeCells('A1:F1');
    worksheet.getCell('A1').value = companyName;
    worksheet.getCell('A1').font = { bold: true, size: 14 };
    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.mergeCells('A2:F2');
    worksheet.getCell('A2').value = contactDetails;
    worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };

    worksheet.mergeCells('A3:F3');
    worksheet.getCell('A3').value = createdBy;
    worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };

    // Leaving an empty row for spacing
    worksheet.addRow([]);

    // Adding headers for the table
    const headerRow = ['S.No', 'Brand', 'Category', 'Thickness', 'Size', 'Product Name', 'Quantity', 'Amount'];
    worksheet.addRow(headerRow);

    // Applying styles to the header row
    worksheet.getRow(5).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } };
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    let totalQuantity = 0;
    let totalAmount = 0;

    // Adding order details from the data
    this.item_details.forEach((row, index) => {
      worksheet.addRow([
        index + 1, // S.No
        row.brand, // Brand
        row.product_type, // Category
        row.thickness, // Thickness
        row.size, // Size
        row.product_name, // Product Name
        row.qty, // Quantity
        row.total_price // Amount
      ]);

      totalQuantity += parseInt(row.qty);
      totalAmount += parseFloat(row.total_price);
    });

    // Adjust column widths
    worksheet.getColumn(1).width = 8;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 15;
    worksheet.getColumn(5).width = 15;
    worksheet.getColumn(6).width = 30;
    worksheet.getColumn(7).width = 15;
    worksheet.getColumn(8).width = 15;

    // Add total row for products
    const totalRow = ['', '', '', '', '', 'Total', totalQuantity, totalAmount.toFixed(2)];
    worksheet.addRow(totalRow);

    // Style the total row
    worksheet.getRow(worksheet.lastRow.number).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFE699' } };
    });

    // Leave a blank row before adding summary details
    worksheet.addRow([]);

    // Adding summary details (Total Amount, Discount, Net Price, GST, Grand Total)
    const summaryRows = [
      ['Total Amount', `₹ ${this.secondaryOrderDetail.order_total.toFixed(2)}`],
      [`Total Discount (${this.secondaryOrderDetail.extraDiscountPercentage}%)`, `₹ ${this.secondaryOrderDetail.extra_discount_amount.toFixed(2)}`],
      ['Net Price', `₹ ${this.secondaryOrderDetail.priceAfterextraDiscount.toFixed(2)}`],
      ['GST (18%)', `₹ ${this.secondaryOrderDetail.totalGSTApplied.toFixed(2)}`],
      ['Grand Total', `₹ ${this.secondaryOrderDetail.totalPriceAfterGST.toFixed(2)}`]
    ];

    summaryRows.forEach(([label, value]) => {
      worksheet.addRow([ '', '', '', '', '', '',label, value]);
    });

    // Apply styles to the summary rows
    summaryRows.forEach((_, index) => {
      worksheet.getRow(worksheet.lastRow.number - index).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { vertical: 'middle', horizontal: 'right' };
      });
    });

    // Save the Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Order Details.xlsx';
      a.click();
    });
}
goToPage(id){
  this.route1.navigate(['/lead-list/lead-detail/'+ id], { queryParams: { 'id': id ,'routes': 'checkin'} })
}


}
